import { render } from "./ColourGroupForm.vue?vue&type=template&id=74eb8cfa"
import script from "./ColourGroupForm.vue?vue&type=script&lang=js"
export * from "./ColourGroupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__